import React from 'react'
import MuiContainer, { ContainerProps } from '@mui/material/Container'

function Container(props: ContainerProps) {
  return <MuiContainer {...props} />
}

export { Container }
